import {css, StyleSheet} from 'aphrodite';
import classNames from 'classnames';
import React from 'react';

import CheckboxInput from 'ui-library/inputs/CheckboxInput';

export interface ExcludeDuplicatesCheckboxProps {
  excludeDuplicates: boolean;
  setExcludeDuplicates: (excludeDuplicates: boolean) => void;
}

export default function ExcludeDuplicatesCheckbox(props: ExcludeDuplicatesCheckboxProps): JSX.Element {
  return (
    <CheckboxInput
      className={classNames('u-spacing-top', css(styles.checkboxWrapper))}
      checked={props.excludeDuplicates}
      id="exclude-duplicates-checkbox"
      label="Exclude duplicate values"
      onChange={(e) => {
        props.setExcludeDuplicates(e.target.checked);
      }}
    />
  );
}

const styles = StyleSheet.create({
  checkboxWrapper: {
    display: 'flex',
  },
});
